import { Icon } from "@iconify/react";
import Dashboard from "./Dashboard";
import LoginActivity from "./LoginActivity";
import RevenueAnalytics from "./RevenueAnalytics";
import MenuCustomization from "./MenuCustomization";
import Knowledgebase from "./Knowledgebase";
import ThemeBuilder from "./ThemeBuilder";
import SupportApp from "./SupportApp";
import LocationCreator from "./LocationCreator";
import CustomValueForm from "./CustomValueForm";
import LocationIntiater from "./LocationIntiater";
import Articles from "./Artciles";
import PhoneBridge from "./PhoneBridge";

const routes = [
  {
    title: "Insights",
    icon: <Icon icon="solar:chart-2-bold-duotone" className="menu-icon" />,
    key: "insights",
    items: [
      {
        title: "CRM Analytics",
        key: "dashboard",
        route: "/dashboard",
        component: <Dashboard />,
      },
      // {
      //   title: "Revenue Analytics",
      //   key: "revenue-analytics",
      //   route: "/revenue-analytics",
      //   component: <RevenueAnalytics />,
      // },
      {
        title: "Login Activity",
        key: "login-activity",
        route: "/login-activity",
        component: <LoginActivity />,
      },
    ],
  },
  //  {
  //   icon: <Icon icon="solar:widget-2-bold-duotone" className="menu-icon" />,
  //   title: "Dashboard",
  //   key: "dashboard",
  //   route: "/dashboard",
  //   component: <Dashboard />,
  // },
  {
    icon: <Icon icon="solar:layers-minimalistic-bold-duotone" className="menu-icon" />,
    title: "Menu Customization",
    key: "menu_customization",
    route: "/menu_customization/*",
    component: <MenuCustomization />,
  },
  {
    icon: <Icon icon="solar:book-2-bold-duotone" className="menu-icon" />,
    title: "Knowledgebase",
    key: "knowledgebase",
    route: "/knowledgebase/*",
    component: <Knowledgebase />,
  },
  {
    icon: <Icon icon="solar:palette-bold-duotone" className="menu-icon" />,
    title: "ThemeBuilder",
    key: "theme-builder",
    route: "/theme-builder/*",
    component: <ThemeBuilder />,
  },
  {
    icon: <Icon icon="solar:chat-round-dots-bold-duotone" className="menu-icon" />,
    title: "Support",
    key: "support",
    route: "/support/*",
    component: <SupportApp />,
  },
  {
    icon: <Icon icon="solar:clipboard-text-bold-duotone" className="menu-icon" />,
    title: "Custom Value Form",
    key: "custom-value-form",
    route: "/custom-value-form",
    component: <CustomValueForm />,
  },
  {
    icon: <Icon icon="solar:map-point-add-bold-duotone" className="menu-icon" />,
    title: "Location Creator",
    key: "location-creator",
    route: "/location-creator",
    component: <LocationCreator />,
  },
  {
    icon: <Icon icon="solar:routing-2-bold-duotone" className="menu-icon" />,
    title: "Location Intiater",
    key: "location-intiater",
    route: "/location_intiater",
    component: <LocationIntiater />,
  },
   {
    icon: <Icon icon="solar:phone-rounded-bold-duotone" className="menu-icon" />,
    // title: "Phone Bridge",
    key: "phone_bridge",
    route: "/phone_bridge",
    component: <PhoneBridge />,
  },
  {
    icon: <Icon icon="solar:document-text-bold-duotone" className="menu-icon" />,
    // title: "GHL Articles",
    key: "ghl-articles",
    route: "/ghl-articles",
    component: <Articles />,
  },
];

export default routes;
